/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
// import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { Autocomplete, RenderInputParams } from '@material-ui/lab';
import { TextField, CircularProgress } from '@material-ui/core';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import { FetchPolicy } from 'apollo-client';
import gql from 'graphql-tag';
import { client } from '../..';
import { IAutoCompleteItem } from '../../typings/autoComplete';
import { showNotification } from '../../App';

// const useStyles = makeStyles((theme: Theme) =>
//   createStyles({
//     root: {
//         minWidth: '150px',
//     },
//   })
// );

interface TimezoneSelectorProps {
    disabled?: boolean;
    required?: boolean;
    multiple?: boolean;
    // tslint:disable-next-line: no-any
    value?: IAutoCompleteItem | any; // value only available in single select
    error?: boolean;
    onSelection?: (value?: IAutoCompleteItem | IAutoCompleteItem[], name?: string) => void;
    className?: string;
    helperText?: string;
    name?: string;
    label?: string;
    style?: React.CSSProperties; 
    disablePortal?: boolean;
    // tslint:disable-next-line: no-any
    defaultValue?: IAutoCompleteItem | any; // value only available in single select
    onBlur?: React.FocusEventHandler<HTMLDivElement>;
    variant?: 'standard' | 'outlined' | 'filled';
    size?: 'small' | 'medium';
}

interface TimezoneSelectorState {
    isLoading: boolean;
    data: IAutoCompleteItem[];
}

export const TimezoneSelector: React.FC<TimezoneSelectorProps> = props => {

    // const classes = useStyles();

    const [state, setState] = useState<TimezoneSelectorState>({
        isLoading: false,
        data: [],
    });

    useEffect(() => {   
        fetchData();
    // tslint:disable-next-line: align
    }, []);

    const fetchData = () => {

        setState({
            ...state,
            isLoading: true
        });
        retrieveTimezoneOptionData(
            false,
            // tslint:disable-next-line: no-console
            (data) => onRetrieveData(data),
            // tslint:disable-next-line:no-any
            function (reason: any): void {
                showNotification(null, reason, 'error');
            }
        );
    };

    const onRetrieveData = (data: TimezoneOptionData) => {
        setState({
            ...state,
            data: data.options.timezoneOption.map((source: TimezoneOption) => ({ 
                ...source, 
                value: source.timezoneValue, 
                label: source.displayName, 
                secondaryValue: source.baseUtcOffset 
            })),
            isLoading: false
        });
    };

    // tslint:disable-next-line: no-any
    const handleChange = (event: React.ChangeEvent<{}>, value: any) => {
        if (props.onSelection) {
            props.onSelection(value, props.name);
        }
    };

    const getInputProps = (params: RenderInputParams, isLoading?: boolean) => {
        return  ({   
            ...params.InputProps,
            endAdornment: (
                <React.Fragment>
                  {isLoading ? <CircularProgress color="primary" size={20} /> : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),     
         });
    };

    return (
        <>
            { props.multiple ? 
                (
                    <Autocomplete
                        style={props.style}
                        className={props.className}
                        // [] (not null) is MUI's "nothing selected" sentinel for multiple={true}.
                        value={Array.isArray(props.value) ? props.value : []}
                        multiple={true}
                        loading={state.isLoading}
                        disabled={props.disabled}
                        onChange={handleChange}
                        options={state.data}
                        disablePortal={props.disablePortal} // to Stop the dropdown select from closing the form
                        // tslint:disable-next-line: jsx-no-lambda
                        getOptionLabel={(option: IAutoCompleteItem) => option.label}
                        getOptionSelected={(option: IAutoCompleteItem, value: IAutoCompleteItem) => option.value === value.value}
                        defaultValue={props.defaultValue}
                        onBlur={props.onBlur}
                        // tslint:disable-next-line: jsx-no-lambda
                        renderInput={params => (
                            <TextField
                                {...params}
                                label={props.label}
                                variant={props.variant ? props.variant : 'standard'}
                                size={props.size ? props.size : 'medium'}
                                fullWidth={true}
                                margin="none"
                                required={props.required}
                                InputProps={getInputProps(params, state.isLoading)}
                                error={props.error}      
                                helperText={props.helperText}                      
                            />
                        )}
                        // tslint:disable-next-line: jsx-no-lambda
                        renderOption={(option, { inputValue }) => {
                            const matches = match(option.label, inputValue);
                            const parts = parse(option.label, matches);
                    
                            return (
                                <div>
                                    {parts.map((part, index) => (
                                        <span key={index} style={{ fontWeight: part.highlight ? 700 : 400 }}>
                                            {part.text}
                                        </span>
                                    ))}
                                </div>
                            );
                        }}
                    />
                )
                :
                (
                    <Autocomplete
                        style={props.style}
                        className={props.className}
                        // Explicit bug report: the raw field value (e.g. '' before anything is
                        // selected) was passed straight through - not an {label,value}-shaped
                        // object matching `options` - causing MUI's getOptionLabel to be called
                        // on a non-object and log "getOptionLabel returned undefined...". null
                        // is MUI's real "nothing selected" sentinel.
                        value={props.value && typeof props.value === 'object' ? props.value : null}
                        loading={state.isLoading}
                        disabled={props.disabled}
                        onChange={handleChange}
                        options={state.data}
                        disablePortal={props.disablePortal} // to Stop the dropdown select from closing the form
                        // tslint:disable-next-line: jsx-no-lambda
                        getOptionLabel={(option: IAutoCompleteItem) => option.label}
                        getOptionSelected={(option: IAutoCompleteItem, value: IAutoCompleteItem) => option.value === value.value}
                        defaultValue={props.defaultValue}
                        onBlur={props.onBlur}
                        // tslint:disable-next-line: jsx-no-lambda
                        renderInput={params => (
                            <TextField
                                {...params}
                                label={props.label}
                                variant={props.variant ? props.variant : 'standard'}
                                size={props.size ? props.size : 'medium'}
                                fullWidth={true}
                                margin="none"
                                required={props.required}
                                InputProps={getInputProps(params, state.isLoading)}
                                error={props.error}                            
                            />
                        )}
                        // tslint:disable-next-line: jsx-no-lambda
                        renderOption={(option, { inputValue }) => {
                            const matches = match(option.label, inputValue);
                            const parts = parse(option.label, matches);
                    
                            return (
                                <div>
                                {parts.map((part, index) => (
                                    <span key={index} style={{ fontWeight: part.highlight ? 700 : 400 }}>
                                    {part.text}
                                    </span>
                                ))}
                                </div>
                            );
                        }}
                    />
                )
            }
        </>
    );
};

export function retrieveTimezoneOptionData(
    refreshData: boolean,
    onSuccess: (data: TimezoneOptionData) => void,
    // tslint:disable-next-line:no-any
    onError: (reason: any) => void
): void {
    var fetchPolicy: FetchPolicy = refreshData === true ? 'network-only' : 'cache-first';
    client
        .query({
            query: TimezoneSelectorQuery,
            variables: {},
            fetchPolicy: fetchPolicy,
        })
        // tslint:disable-next-line:no-any
        .then((results: { data: any }) => {
            onSuccess(results.data);
        })
        // tslint:disable-next-line:no-any
        .catch((reason: any) => {
            onError(reason);
        });
}

export interface TimezoneOptionData {
    loading?: boolean;
    networkStatus?: number;
    options: Options;
}

export interface Options {
    timezoneOption: TimezoneOption[];
}

export interface TimezoneOption {
    id: number;
    timezoneValue: string;
    displayName: string;
    baseUtcOffset: number;
}

const TimezoneSelectorQuery = gql`
    query TimezoneOptions {
        options{
            timezoneOption{
                id,
                timezoneValue,
                displayName
                baseUtcOffset
            }
        }
    }
`;